import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function adminFundsList({ amc_code }) {
  return ApiRequest.fetchAdmin({
    method: "get",
    url: `${API_END_POINTS.ADMIN_FUNDS}?amc_code=${amc_code}`,
  }).then((response) => response.data);
}
